<div mat-dialog-title class="modal-header">
  <h2>Recherche annuaire</h2>
  <button type="button" class="close-button" (click)="this.dialogRef.close()">
    <mat-icon>close</mat-icon>
  </button>
</div>
<mat-dialog-content>
  <div class="sticky-tabs">
    <mat-tab-group [(selectedIndex)]="selectedTabIndex" (selectedIndexChange)="onTabChanged($event)">
      <mat-tab label="Annuaire Santé en ligne"></mat-tab>
      <mat-tab label="Annuaire Apicrypt en ligne"></mat-tab>
      <mat-tab label="Annuaire Santé local"></mat-tab>
    </mat-tab-group>
  </div>
  <div class="tab-content">
    <!-- Annuaire Apicrypt (LDAP)-->
    <div class="annuaire-container" *ngIf="selectedTabIndex === 1">
      <frg-cards class="annuaire-card" title="Annuaire Apicrypt (LDAP)">
        <div class="card">
            <div class="card-body-correspondant">
              <div class="text-infos">* Recherche uniquement les correspondants ayant une adresse Apicrypt</div>
                <button mat-button type="button" *ngIf="isformGroupDirty" color="warn" class="reset-button" (click)="resetSearchForm()">
                  <mat-icon>clear</mat-icon>Réinitialiser</button>
                <form (ngSubmit)="doSearchRecipientsApi()" *ngIf="formGroup">
                  <span class="inputs-column">
                    <frg-form-input label="Nom d'exercice" id="exerciceName" type="text"
                      [formGroup]="formGroup" [control]="formGroup.get('exerciceName')">
                    </frg-form-input>
                    <frg-form-input label="Prénom usuel" id="firstName"
                      type="text" [formGroup]="formGroup" [control]="formGroup.get('firstName')">
                    </frg-form-input>
                    <frg-form-input label="Profession" id="professionSpeciality" type="text"
                      [formGroup]="formGroup" [control]="formGroup.get('professionSpeciality')">
                    </frg-form-input>
                    <frg-form-input
                      label="Code postal"
                      id="zip"
                      type="text"
                      [formGroup]="formGroup"
                      [control]="formGroup.get('zip')"
                    ></frg-form-input>
                    <frg-form-input
                      label="Ville"
                      id="city"
                      type="text"
                      [formGroup]="formGroup"
                      [control]="formGroup.get('city')"
                    ></frg-form-input>
                  </span>
                </form>
            </div>
            <div class="button-wrapper" *ngIf="formGroup">
              <frg-button backgroundColor="var(--primary)" (activated)="doSearchRecipientsApi()" [disabled]="isSearching || !formGroup.valid">Rechercher</frg-button>
              <div class="alert-troncated-result" *ngIf="result && result.result.length > 0 && result.troncated"
                title="Seuls les 100 premiers résultats peuvents être affichés.">
                <div>Nombre de résultats important, utilisez les filtres pour affiner votre recherche</div>
              </div>
            </div>
            <div class="link-web-site" (click)="redirectToSiteAnnuaireApi()">
                Site web de l'annuaire Apicrypt
            </div>
        </div>
      </frg-cards>
      <frg-cards class="infos-card" [border]="false"
      [title]="correspondantsFiltred ? 'Liste des résultats de la recherche : ' + (result.total > result.result.length
        ? 'plus de ' + result.result.length : result.result.length) +' résultat(s) trouvé(s)': ''">
        <ng-container *ngIf="isSearching; else resultBlock">
          <div class="custom-spinner-wrapper">
            <div class="custom-spinner"></div>
          </div>
        </ng-container>
        <ng-template #resultBlock>
          <div class="card-body-infos">
            <div class="correspondants-list" *ngIf="correspondantsFiltred">
              <div class="correspondants" *ngFor="let correspondant of correspondantsFiltred"
                  (click)="openDetails(correspondant)">
                <div class="correspondant-name">
                  <p>{{correspondant.nom ? correspondant.nom : ''}} {{correspondant.prenom ?
                        correspondant.prenom : ''}}</p>
                  <p>{{correspondant.adresseApiCrypt ? correspondant.adresseApiCrypt : ''}}</p>
                </div>
                <div class="correspondant-name">
                  <strong>{{correspondant.codePostal ? correspondant.codePostal : ''}} {{correspondant.ville ? correspondant.ville : ''}}</strong>
                </div>
              </div>
              <div class="no-info" *ngIf="correspondantsFiltred.length === 0">
                <p>Votre recherche n'a retourné aucun résultat</p>
              </div>
            </div>
          </div>
        </ng-template>

      </frg-cards>
    </div>
    <!-- Annuaire Santé (LDAP) -->
    <div class="annuaire-container" *ngIf="selectedTabIndex === 0">
      <frg-cards class="annuaire-card" title="Annuaire Santé (LDAP)">
        <div class="card">
            <div class="card-body-correspondant">
              <div class="text-infos">* Recherche uniquement les correspondants ayant une adresse MSsanté</div>
                <button mat-button type="button" *ngIf="isformGroupDirty" color="warn" class="reset-button" (click)="resetSearchForm()">
                      <mat-icon>clear</mat-icon>Réinitialiser</button>
                <form (ngSubmit)="doSearchRecipients()" *ngIf="formGroup">
                  <span class="inputs-column">

                    <frg-form-input label="Nom d'exercice" id="exerciceName" type="text"
                      [formGroup]="formGroup" [control]="formGroup.get('exerciceName')">
                    </frg-form-input>
                    <frg-form-input label="Prénom d'exercice" id="firstName"
                      type="text" [formGroup]="formGroup" [control]="formGroup.get('firstName')">
                    </frg-form-input>
                    <frg-form-input label="Profession" id="profession" type="text"
                      [formGroup]="formGroup" [control]="formGroup.get('profession')">
                    </frg-form-input>
                    <frg-form-input label="Spécialité" id="speciality" type="ngSelect"
                      [selectValue]="specialites" [formGroup]="formGroup" [control]="formGroup.get('speciality')">
                    </frg-form-input>
                    <frg-form-input label="RPPS" id="rpps" type="text"
                      [formGroup]="formGroup" [control]="formGroup.get('rpps')">
                    </frg-form-input>
                    <frg-form-input label="Structure / Adresse" id="structureOrAddress" type="text"
                      [formGroup]="formGroup" [control]="formGroup.get('structureOrAddress')">
                    </frg-form-input>
                    <frg-form-input label="Adresse e-mail MSS" id="email" type="text"
                      [formGroup]="formGroup" [control]="formGroup.get('email')">
                    </frg-form-input>
                    <frg-form-input
                      label="Code postal"
                      id="zip"
                      type="text"
                      [formGroup]="formGroup"
                      [control]="formGroup.get('zip')"
                    ></frg-form-input>
                    <frg-form-input
                      label="Ville"
                      id="city"
                      type="text"
                      [formGroup]="formGroup"
                      [control]="formGroup.get('city')"
                    ></frg-form-input>
                  </span>
                </form>
            </div>
            <div class="button-wrapper" *ngIf="formGroup">
              <frg-button backgroundColor="var(--primary)" (activated)="doSearchRecipients()" [disabled]="isSearching || !formGroup.valid">Rechercher</frg-button>
              <div class="alert-troncated-result" *ngIf="result && result.result.length > 0 && result.troncated"
                title="Seuls les 100 premiers résultats peuvents être affichés.">
                <div>Nombre de résultats important, utilisez les filtres pour affiner votre recherche</div>
              </div>
            </div>
            <div class="link-web-site" (click)="redirectToSiteAnnuaire()">
                Site web de l'annuaire de santé
            </div>
        </div>
      </frg-cards>
      <frg-cards class="infos-card" [border]="false"
      [title]="correspondantsFiltred ? 'Liste des résultats de la recherche : ' + (result.total > result.result.length
        ? 'plus de ' + result.result.length : result.result.length) +' résultat(s) trouvé(s)': ''">
        <ng-container *ngIf="isSearching; else resultBlock">
          <div class="custom-spinner-wrapper">
            <div class="custom-spinner"></div>
          </div>
        </ng-container>
        <ng-template #resultBlock>
          <div class="card-body-infos">
            <div class="correspondants-list" *ngIf="correspondantsFiltred">
              <div class="correspondants" *ngFor="let correspondant of correspondantsFiltred"
                  (click)="openDetails(correspondant)">
                <div class="correspondant-name">
                  <p>{{correspondant.nom ? correspondant.nom : ''}} {{correspondant.prenom ? correspondant.prenom : ''}}</p>
                  <p *ngIf="correspondant.professionName || correspondant.specialiteName">
                    {{correspondant.professionName ? correspondant.professionName : ''}} 
                    <span *ngIf="correspondant.professionName && correspondant.specialiteName">-</span> 
                    {{correspondant.specialiteName ? correspondant.specialiteName : ''}}
                  </p>
                  <p *ngIf="correspondant.rpps">RPPS : {{correspondant.rpps}}</p>
                  <p>{{correspondant.email2 ? correspondant.email2 : ''}}</p>
                </div>
                <div class="correspondant-name">
                  <p *ngIf="correspondant.adresse1">{{correspondant.adresse1}}</p>
                  <strong>{{correspondant.codePostal ? correspondant.codePostal : ''}} {{correspondant.ville ? correspondant.ville : ''}}</strong>
                </div>
              </div>
              <div class="no-info" *ngIf="correspondantsFiltred.length === 0">
                <p>Votre recherche n'a retourné aucun résultat</p>
              </div>
            </div>
          </div>
        </ng-template>

      </frg-cards>
    </div>
        <!-- Annuaire local mssante -->
    <div class="annuaire-container" *ngIf="selectedTabIndex === 2">
        <frg-cards class="annuaire-card" title="Annuaire Santé local">
            <div class="card">
                <div class="card-body-correspondant">
                                            <button mat-button type="button" *ngIf="isSearchFormDirty" color="warn" class="reset-button" (click)="resetSearchForm()">
                          <mat-icon>clear</mat-icon>Réinitialiser</button>
                    <form [formGroup]="searchCorrespondantForm" (ngSubmit)="submitSearchCorrespondant()"
                        *ngIf="searchCorrespondantForm">
                        <frg-form-input label="Spécialité" id="speciality" type="ngSelect" [selectValue]="refSpecialite"
                            [formGroup]="searchCorrespondantForm" [control]="searchCorrespondantForm.get('speciality')">
                        </frg-form-input>
                        <frg-form-input label="Nom" id="nom" type="text" placeholder="Ex: Dupont"
                            [formGroup]="searchCorrespondantForm" [control]="searchCorrespondantForm.get('nom')"
                            class="search-form-input align">
                        </frg-form-input>
                        <frg-form-input label="Code postal" id="codePostal" type="text" placeholder="Ex: 44000"
                            [formGroup]="searchCorrespondantForm" [control]="searchCorrespondantForm.get('codePostal')"
                            class="search-form-input align">
                        </frg-form-input>
                        <frg-form-input label="Ville" id="ville" type="text" placeholder="Ex: Nantes"
                            [formGroup]="searchCorrespondantForm" [control]="searchCorrespondantForm.get('ville')"
                            class="search-form-input align">
                        </frg-form-input>
                        <frg-button [disabled]="!searchCorrespondantForm.valid" [type]="'submit'" class="search-button" [backgroundColor]="'var(--primary)'">Lancer la
                            recherche</frg-button>
                    </form>
                </div>
                <div class="link-web-site" (click)="redirectToSiteAnnuaire()">
                    Site web de l'annuaire de santé
                </div>
            </div>

        </frg-cards>
        <frg-cards class="infos-card" [border]="false" [title]="correspondantsFiltred ? 'Liste des résultats de la recherche' : ''">
            <div class="card-body-infos">
                <div class="correspondants-list" *ngIf="correspondantsFiltred">
                    <div class="correspondants" *ngFor="let correspondant of correspondantsFiltred"
                        (click)="openDetails(correspondant)">
                        <div class="correspondant-name">
                            <p>{{correspondant.nom ? correspondant.nom : ''}} {{correspondant.prenom ?
                                correspondant.prenom : ''}}</p>
                        </div>
                        <div class="correspondant-name">
                          <strong>{{correspondant.codePostal ? correspondant.codePostal : ''}} {{correspondant.ville ? correspondant.ville : ''}}</strong>
                        </div>
                        <div [ngClass]="{'badge': true, 'annuaire': correspondant.isFromAnnuaire, 'repertoire': !correspondant.isFromAnnuaire}">
                            {{ correspondant.isFromAnnuaire ? 'Annuaire de santé' : 'Répertoire du cabinet'}}
                        </div>
                    </div>
                    <div class="no-info" *ngIf="correspondantsFiltred.length === 0">
                        <p>Votre recherche n'a retourné aucun résultat</p>
                    </div>
                </div>

            </div>
        </frg-cards>
    </div>
  </div>
</mat-dialog-content>
<div class="footer">
    <mat-dialog-actions align="end">
        <button mat-stroked-button type="button" class="cancel-button" (click)="this.dialogRef.close()">Fermer</button>
    </mat-dialog-actions>
</div>
